import dayjs from 'dayjs'
export default {
  name: 'company-notice-detail',
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD')
    }
  },
  data: () => ({
    company_notice: null,
    isGetCompanyNotice: false
  }),
  created: async function () {
    // 全社通達取得
    await this.getCompanyNotice()
    // 全社通達既読処理
    await this.updCompanyNoticeRead()
  },
  methods: {
    goBack () {
      // 戻る処理
      const currentPage = (this.$route.query.current_page) ? this.$route.query.current_page : 0
      this.$router.push({ path: '/company_notice_list', query: {current_page: currentPage} })
    },
    goCompanyNoticeList () {
      // 全社通達一覧に戻る
      const currentPage = (this.$route.query.current_page) ? this.$route.query.current_page : 0
      this.$router.push({ path: '/company_notice_list', query: {current_page: currentPage} })
    },
    async getCompanyNotice () {
      // 全社通達取得
      let res = await this.$store.dispatch('GET_COMPANY_NOTICE_DETAIL', {id: this.$route.params.company_notice_id})
      .catch(err => {
        console.error(err)
        return
      })
      if (res.company_notices) {
        this.company_notice = res.company_notices
      }
      this.isGetCompanyNotice = true
    },
    async updCompanyNoticeRead () {
      // 全社通達既読処理
      await this.$store.dispatch('COMPANY_NOTICE_ALREADY_READ_UPDATE', {id: this.$route.params.company_notice_id})
      .catch(err => {
        console.error(err)
        return
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-detail.js